/* eslint-disable react/require-default-props */
import Box from '@mui/material/Box';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export interface ILoaderData {
  alignItems?: string;
  muiLoaderProps?: CircularProgressProps;
  size?: number;
}

const Loader = ({ alignItems, ...other }: ILoaderData) => (
  <Box sx={{ width: '100%' }}>
    <Box sx={{ display: 'flex', justifyContent: alignItems || 'flex-start' }}>
      <CircularProgress {...other} color="primary" />
    </Box>
  </Box>
);

export default Loader;
